import { ModalWindow, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import { MoscowDistrictsHeader } from './header';
import { DistrictsLayout, isMoscowLocation } from './layout';
import { IJsonQueryDistrict } from '../../../../../packages/api-models/common/json_query';
import { TLocation } from 'shared/types/location';

import style from './index.css';
import { IGeoDistrict } from 'shared/types/geo/districts';

export interface IStateProps {
  isDataLoading: boolean;
  districts: IGeoDistrict[] | undefined;
  selectedLocation: TLocation;
  selectedDistricts: IJsonQueryDistrict[];
  includeNewMoscow: boolean | null;
  searchButton: React.ReactNode;
}

export interface IDispatchProps {
  onClose(): void;
  onSelected(id: number, name: string): void;
  onNewMoscowSwitched(includeNewMoscow: boolean | null): void;
  onRemoved(id: number): void;
}

export type TDistrictsModalProps = IStateProps & IDispatchProps;

export class DistrictsModal extends React.Component<TDistrictsModalProps> {
  public render() {
    return (
      <ModalWindow
        fixed
        size="M"
        escape
        width="100%"
        maxWidth={1300}
        open
        onClose={this.props.onClose}
        header={
          isMoscowLocation(this.props.selectedLocation) && (
            <MoscowDistrictsHeader
              includeNewMoscow={this.props.includeNewMoscow}
              onNewMoscowSwitched={this.props.onNewMoscowSwitched}
            />
          )
        }
        footer={<div className={style.footer}>{this.props.searchButton}</div>}
      >
        <div>
          {this.props.isDataLoading && (
            <div className={style['preloader-wrapper']}>
              <Spinner size={50} />
            </div>
          )}
          {this.props.districts && this.renderDistricts(this.props.districts)}
        </div>
      </ModalWindow>
    );
  }

  private renderDistricts(districts: IGeoDistrict[]) {
    return (
      <div className={style.districts}>
        <DistrictsLayout
          areas={districts}
          selectedLocation={this.props.selectedLocation}
          selectedDistricts={this.props.selectedDistricts}
          onSelected={this.props.onSelected}
          onRemoved={this.props.onRemoved}
        />
      </div>
    );
  }
}
